import React, { useMemo } from 'react';
import { Info } from 'lucide-react';
import { htmlToPlainText } from '../utils/htmlToPlainText';

interface ReviewStepProps {
  selectedCount: number;
  subject: string;
  body: string;
}

const ReviewRow: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => (
  <div className="flex items-start gap-3">
    <p className="w-[116px] shrink-0 text-sm leading-5 text-[#737373]">{label}</p>
    <div className="min-w-0 flex-1 text-sm leading-5 text-[#0A0A0A]">{children}</div>
  </div>
);

const ReviewSeparator = () => (
  <div className="py-2">
    <div className="h-px w-full bg-[#E5E5E5]" />
  </div>
);

export const ReviewStep: React.FC<ReviewStepProps> = ({
  selectedCount,
  subject,
  body,
}) => {
  const plainBody = useMemo(() => htmlToPlainText(body), [body]);
  const recipientsLabel = `${selectedCount} destinatário${
    selectedCount === 1 ? '' : 's'
  } selecionado${selectedCount === 1 ? '' : 's'}`;

  return (
    <div className="flex flex-col gap-6">
      <div className="overflow-hidden rounded-[10px] border border-[#E5E5E5] bg-white">
        <div className="bg-[linear-gradient(0deg,rgba(255,255,255,0.5),rgba(255,255,255,0.5)),#F5F5F5] px-6 py-6">
          <h2 className="text-lg font-semibold leading-7 tracking-[-0.4px] text-[#0A0A0A]">
            Resumo do envio
          </h2>
        </div>

        <div className="flex flex-col gap-3 px-6 py-6">
          <ReviewRow label="Destinatários">
            <p className="font-medium">{recipientsLabel}</p>
          </ReviewRow>

          <ReviewSeparator />

          <ReviewRow label="Canal de envio">
            <p className="font-medium">E-mail</p>
          </ReviewRow>

          <ReviewSeparator />

          <ReviewRow label="Assunto">
            <p className="font-medium">{subject}</p>
          </ReviewRow>

          <ReviewSeparator />

          <ReviewRow label="E-mail">
            <p className="whitespace-pre-wrap font-normal">{plainBody}</p>
          </ReviewRow>
        </div>
      </div>

      <div className="flex items-start gap-3 rounded-xl bg-[#DBEAFE] px-3.5 pb-4 pt-3.5">
        <Info className="mt-0.5 h-5 w-5 shrink-0 text-[#2563EB]" strokeWidth={2} />
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <p className="text-sm font-medium leading-5 text-[#0A0A0A]">Envio</p>
          <p className="text-sm font-normal leading-5 text-[#0A0A0A]/[.72]">
            Após confirmação, o envio será iniciado imediatamente. Os destinatários
            receberão o report no(s) canal(is) configurado(s). Esta ação não pode ser
            desfeita.
          </p>
        </div>
      </div>
    </div>
  );
};
